export default {
  FETCH_NEW_LABEL_STATUS_REQUEST: 'FETCH_NEW_LABEL_STATUS_REQUEST',
  FETCH_NEW_LABEL_STATUS_SUCCESS: 'FETCH_NEW_LABEL_STATUS_SUCCESS',
  FETCH_NEW_LABEL_STATUS_FAILURE: 'FETCH_NEW_LABEL_STATUS_FAILURE',

  SET_NEW_LABEL_STATUS_REQUEST: 'SET_NEW_LABEL_STATUS_REQUEST',
  SET_NEW_LABEL_STATUS_SUCCESS: 'SET_NEW_LABEL_STATUS_SUCCESS',
  SET_NEW_LABEL_STATUS_FAILURE: 'SET_NEW_LABEL_STATUS_FAILURE',

  PREFETCH_DOCUMENT_REQUEST: 'PREFETCH_DOCUMENT_REQUEST',
  PREFETCH_DOCUMENT_SUCCESS: 'PREFETCH_DOCUMENT_SUCCESS',
};



// WEBPACK FOOTER //
// ./src/modules/documents/actions/action-types.js